<template>
  <div class="boutique">
    <div class="first-line">
      <div class="search">
        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="input"></el-input>
      </div>
      <!-- <div class="msgImg" @click="goReport">
        <img src="@/assets/boutique/dp-jy-sy2.png" alt />
        <span>学习记录</span>
      </div> -->
    </div>
    <div class="second-line">
      <div class="second-line-1">
        <div class="left">
          <img src="@/assets/boutique/dp-jy-sy3.png" alt />
        </div>
        <div class="right">
          <p>积极参与党建课件学习</p>
          <p>做一名优秀共产党员</p>
        </div>
      </div>
      <div class="second-line-2">
        <div v-for="icon in icons" :key="icon.name" @click="goList(icon.name)">
          <img :src="icon.imgUrl" alt />
          <p v-text="icon.name"></p>
        </div>
      </div>
      <!-- <div class="second-line-3">
        <img src="@/assets/boutique/dp-jy-sy14.png" />
      </div> -->
    </div>

    <div class="third-line">
      <div class="third-line-1">
        <div
          v-for="thirdIcon in thirdIcons"
          :key="thirdIcon.name"
          @click="goIframe(thirdIcon.name)"
        >
          <img :src="thirdIcon.imgUrl" alt :class="{ 'third-icon': thirdIcon.name == '12371共产党员网' }"/>
          <p v-if="thirdIcon.name == '12371共产党员网'">12371<br/>共产党员网</p>
          <p v-else-if="thirdIcon.name == '共产党员手机报'">共产党员<br/>手机报</p>
          <p v-else-if="thirdIcon.name == '四川党建网'">四川<br/>党建网</p>
        </div>
      </div>
    </div>

    <div class="four-line">
      <div class="title">
        <img src="@/assets/boutique/dp-jy-sy15.png" alt />
        <span>热门学习课件</span>
      </div>
      <div class="class-box">
        <div
          class="class-template"
          v-for="four in fours"
          :key="four.Vid"
          @click="goVedio(four)"
        >
          <img :src="four.VideoImage | filterB" alt />
          <p class="h-line-1" v-text="four.HeadLine"></p>
          <p class="h-line-2" v-text="four.VideoTitle"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'

export default {
  data() {
    return {
      input: "",
      icons: [
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy4.png"),
          name: "典型经验"
        },
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy5.png"),
          name: "本土课件"
        },
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy6.png"),
          name: "经营管理"
        },
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy7.png"),
          name: "政治理论"
        },
        { imgUrl: require("@/assets/boutique/dp-jy-sy8.png"), name: "科普知识" }
      ],
      thirdIcons: [
        {
          // imgUrl: require("@/assets/boutique/partyHistory-education.png"),
          // name: "党史教育"
          imgUrl: require("@/assets/boutique/img_12371_1.webp"),
          name: "12371共产党员网"
        },
        {
          imgUrl: require("@/assets/boutique/img_phone_2.webp"),
          name: "共产党员手机报"
        },
        // {
        //   imgUrl: require("@/assets/boutique/dp-jy-sy10.png"),
        //   name: "12371流媒体视频"
        // },
        {
          imgUrl: require("@/assets/boutique/img_sc_3.webp"),
          name: "四川党建网"
        },
      ],
      fours: [
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy16.png"),
          title: "平“语”近人",
          source: "共产党员网·2018.02.03"
        },
        {
          imgUrl: require("@/assets/boutique/dp-jy-sy17.png"),
          title: "听学新思想",
          source: "共产党员网·2018.02.03"
        }
      ]
    };
  },
  methods: {
    goReport() {
      this.$router.push({
        path: "/boutique/studyRecord",
        query: { title: "学习记录" }
      });
    },
    goVedio(sourceLink) {    
      this.$router.push({
        path: "/boutique/videoPlayer",
        query: { title: "视频播放", source: JSON.stringify(sourceLink) }
      });
    },
    goList(name) {
      this.$router.push({
        path: "/boutique/list",
        query: { title: name }
      });
    },
    getList() {
      this.axios.get("/api/Courseware/Video").then(e => {
        if (e.data.code == 0) {
          this.fours = e.data.msg;
        }
      });
    },
    goIframe(name) {
      switch (name) {
        case "党史教育":
          this.$router.push({
            path: "/iframeVedio",
            query: { title: name, iframeUrl: "https://www.12371.cn/dsxx/" }
          });
          break;
        case "12371共产党员网11":
          this.$router.push({
            path: "/iframeVedio",
            query: { title: name, iframeUrl: "https://www.12371.cn/" }
          });
          break;
        case "12371流媒体视频":
          MessageBox.alert('对不起，由于版权原因，视频无法播放')
          // this.$router.push({
          //   path: "/iframeVedio",
          //   query: { title: name, iframeUrl: "https://dygbjy.12371.cn/zbpd/" }
          // });
            // this.$router.push({ // http://dygbjy.12371.cn/zbpd/
            //   path:'/boutique/videoPlayer',
            //   query:{ title:'视频播放',
            //     source:{
            //       VideoPath:'https://12371wbndks.v.kcdnvip.com/12371wbnd/dangyuanwang_2/index.m3u8?BR=hd&region=shanghai'
            //     }
            //   }
            // })
          break;
        case "天府先锋学习课件":
          this.goList('天府先锋')
          break;
        case "眉州先锋学习课件":
          this.goList('眉州先锋')
          //  this.$router.push({path:'/iframeVedio',query:{title:name,iframeUrl:'http://www.12371.cn/'}})
          break;
        case "12371共产党员网":
          this.$router.push({
            path: "/iframeVedio",
            query: { title: name, iframeUrl: "https://www.12371.cn/" }
          });
          break;        
        case "共产党员手机报":
          this.$router.push({
            path: "/iframeVedio",
            query: { title: name, iframeUrl: "https://12371.people.com.cn/" }
          });
          break;        
        case "四川党建网":
          this.$router.push({
            path: "/iframeVedio",
            query: { title: name, iframeUrl: "https://www.scdjw.com.cn" }
          });
          break;
        default:
          break;
      }
    }
  },
  created: function() {
    this.getList();
  },
  filters: {
    filterB: function(value) {
      if (value)
        return value.indexOf("http") > -1
          ? value
          : `http://qswgadmin.djplus.cn/Tittle/${value}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.boutique {
  .four-line {
    .class-box {
      .class-template {
        &:nth-child(odd) {
          margin-right: 2%;
        }
        img {
          width: 100%;
          height: 2.4rem;
        }
        p {
          &:nth-child(3) {
            color: #999999;
            font-size: 0.26rem;
          }
          line-height: 2;
          padding: 0 0.2rem;
        }
        width: 49%;
        background: #fff;
        margin-top: 0.3rem;
        padding-bottom: 0.2rem;
      }
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      padding: 0 0.2rem;
    }
    .title {
      span {
        font-weight: bold;
        font-size: 0.32rem;
      }
      img {
        width: 0.38rem;
        height: 0.45rem;
        margin: 0 0.1rem 0 0.2rem;
      }
      display: flex;
      align-items: center;
      background: #fff;
      line-height: 3;
    }
    margin-top: 0.3rem;
  }
  .third-line {
    .third-line-1 {
      div {
        padding: 0.2rem 0.1rem;
        border-radius: 8px;
        box-sizing: border-box;
        .third-icon{
          transform: translateY(0.1rem);
        }
        img {
          width: 100%;
          height: 1rem;
        }
        p {
          white-space: pre-wrap;
          padding: 0px 0.1rem;
        }
        display: inline-block;
        text-align: center;
        width: 32%;
        margin-right: 2%;
        background: #fff;
      }
      width: 94%;
      margin: 0 auto;
      overflow-x: scroll;
      white-space: nowrap;
    }
    margin-top: 0.3rem;
  }
  .second-line {
    .second-line-3 {
      img {
        width: 94%;
      }
      text-align: center;
      padding: 0.3rem 0;
    }
    .second-line-2 {
      div {
        img {
          width: 45%;
          // width: .75rem;
          // height: .61rem;
        }
        text-align: center;
        display: inline-block;
        width: 20%;
        line-height: 1.5;
        font-size: 0.28rem;
      }
      width: 100%;
      overflow-x: scroll;
      white-space: nowrap;
    }
    .second-line-1 {
      .right {
        p {
          &:nth-child(1) {
            font-weight: bold;
            font-size: 0.34rem;
          }
          &:nth-child(2) {
            color: #999999;
            font-size: 0.26rem;
            line-height: 2;
          }
        }
      }
      .left {
        img {
          width: 0.8rem;
          height: 0.8rem;
          margin-right: 0.2rem;
        }
      }
      display: flex;
      align-items: center;
      margin-top: 0.08rem;
      padding: 0.3rem 0.2rem;
    }

    background: #fff;
  }
  .first-line {
    .msgImg {
      img {
        width: 0.28rem;
        height: 0.3rem;
        // vertical-align: middle;
        margin-right: 0.1rem;
      }
      align-items: center;
    }
    .search {
      input {
        border-radius: 0.3rem;
        background: rgba($color: #e4e0e0, $alpha: 0.4);
      }
      width: 70%;
    }
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: #fff;
    padding: 0.3rem 0;
    box-shadow: 0px 0.04rem 0.06rem 0px rgba(0, 0, 0, 0.06);
  }
  font-size: 0.3rem;
  padding-bottom: 1.3rem;
}
</style>

<style lang="scss" >
.boutique {
  .first-line {
    input {
      border-radius: 0.4rem;
      background: rgba($color: #dcdbdb, $alpha: 0.4);
    }
  }
}
</style>